import {createSelector} from 'reselect';

import * as utils from 'app/procedures/utils';

import type {
  ProcedureParsedContent,
  ProcessVersionSerializedType,
} from 'sweet-types';

// Formatting process description according to procedure description
// so, that the generic file VersionDiffer can compute description differ easily without checks
export const formatPreviousProcessVersion = createSelector<
  ProcessVersionSerializedType | void,
  | (Omit<ProcessVersionSerializedType, 'description'> & {
      description: ProcedureParsedContent['description'];
    })
  | undefined,
  ProcessVersionSerializedType | void
>(
  (process) => process,
  (process) =>
    process != null
      ? {...process, description: utils.getDescription(process)}
      : undefined
);
